import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import theme from 'ui/styles/theme';
import getRelativeUrl from 'utils/getRelativeUrl'
import { Link } from 'react-router-dom'

export default class TechnicalInfoTable extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount = () => {
    }



    render() {
        const { table, table_header, bgcolor } = this.props

        const { } = this.state




        return (
            <Wrapper bgcolor={bgcolor}>
                <InnerWrapper fluid>
                    <TableBox cellSpacing={0}>
                        <thead>
                            <tr>
                                <TableHead colSpan={2} extraPadding={table_header.header_translation}>
                                    {table_header.header_value}
                                    {table_header.header_translation &&
                                        <TableHeadTranslation colSpan={2}>
                                            {table_header.header_translation}
                                        </TableHeadTranslation>
                                    }
                                </TableHead>

                            </tr>
                        </thead>
                        <tbody>
                            {table.map((row, index) =>
                                <tr key={index} id='data-row'>
                                    <TableField>{row.label.label_main}<LabelTranslation>{row.label.label_translation}</LabelTranslation></TableField>
                                    <TableField>{row.value.value_main}<ValueTranslation>{row.value.value_translation}</ValueTranslation></TableField>
                                </tr>
                            )}
                        </tbody>
                    </TableBox>
                </InnerWrapper>
            </Wrapper>
        )
    }
}




const TableBox = styled.table`
width: 100%;
border-spacing: 0; 
border-collapse: collapse !important;

#data-row:nth-child(odd) {
    background: ${theme.colors.tones.lighter};
}
`
const LabelTranslation = styled.p`
margin-bottom: 0px;
font-size: 1em;
`
const ValueTranslation = styled.p`
margin-bottom: 0px;
font-size: 1em;
`


const TableHead = styled.th`
background-color: #004077;
color: white;
padding: 20px;
font-size: 2em;
padding-bottom: ${props => props.extraPadding.length > 0 ? '0px' : '20px'};

}
`

const TableHeadTranslation = styled.p`
padding-bottom: 20px;
padding-top: 0px;
margin-bottom: 0px;
background-color: #004077;
color: rgba(255, 255, 255, 0.69);
font-size: 0.5em;
`


const TableField = styled.td`
padding: 20px;
`

const Heading = styled.h2`
  font-size: 20px;
  text-transform: uppercase;
  margin-bottom: 40px;
  background-color: #004077;
  color: white;
`

const InnerWrapper = styled(Container)`
padding: 0 20px;
${media.lg`
padding: 0 20%;
`}
`


const Wrapper = styled.div`
background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
margin-top: 8%;

${media.lg`
margin-top: 0;
`}
`





// WEBPACK FOOTER //
// ./src/ui/components/modules/TechnicalInfoTable/index.js